import { useCallback, useContext, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { ChainlitContext, sessionIdState } from '@chainlit/react-client';

export interface SessionFile {
    id: string;
    filename: string;
    mime: string;
    generated: boolean;
}

export const useSessionFiles = () => {
    const apiClient = useContext(ChainlitContext);
    const sessionId = useRecoilValue(sessionIdState);
    const [files, setFiles] = useState<SessionFile[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const refresh = useCallback(async () => {
        if (!sessionId) return;
        setIsLoading(true);
        try {
            const res = await apiClient.get(
                `/project/session-files?session_id=${sessionId}`
            );
            const data = await res.json();
            setFiles(data.files || []);
        } catch (error) {
            console.error('Could not load session files', error);
            setFiles([]);
        } finally {
            setIsLoading(false);
        }
    }, [apiClient, sessionId]);

    return { files, isLoading, refresh };
};
